<script>
    import { page } from '$app/stores';

    import StoryMission from '$lib/StoryMission.svelte';
    import Award from '$lib/Award.svelte';
    import Bundles from '$lib/Bundles.svelte';
    import Courses from '$lib/Courses.svelte';
    import Hero from '$lib/Hero.svelte';
    import ScrollableSection from '$lib/ScrollableSection.svelte';
    import Worksheets from '$lib/Worksheets.svelte';
    import H2 from '$lib/H2.svelte';
    import PageLayout from '$lib/PageLayout.svelte';
    import PageSection from '$lib/PageSection.svelte';
    import Faq2 from '$lib/FAQ2.svelte';
    import Reviews4 from '$lib/Reviews4.svelte';
    import { logEvent } from '$lib/utils/logs';
    import BookHero from '$lib/BookHero.svelte';
    import ProductListSchema from '$lib/ProductListSchema.svelte';

    let worksheets = $page.data.worksheets;

    let courses_with_price = $page.data.courses.filter((c) => c.price);
</script>

<PageLayout>
    <Hero />

    <PageSection class="my-8 lg:my-14">
        <H2 lg class="mb-4 pl-4 md:mb-8"
            ><a
                href="/courses"
                class="link"
                on:click={() => logEvent('home-courses-title-click')}
                >Interactive Courses</a
            ></H2
        >

        <ScrollableSection
            class="negate-page-section-px"
            content_class="flex gap-4 md:gap-6 flex-nowrap"
        >
            <Courses
                courses={courses_with_price}
                h_level={3}
                class="snap-center min-w-70 xl:min-w-68"
                feature="courses-list-home"
            />
            <ProductListSchema
                products={courses_with_price}
                name="Interactive Courses"
            />
        </ScrollableSection>
    </PageSection>

    <PageSection class="my-8 lg:my-14">
        <H2 lg class="mb-4 pl-4 md:mb-8"
            ><a
                href="/worksheets"
                class="link"
                on:click={() => logEvent('worksheets-title-click-home')}
                >Worksheets & Lesson Plans</a
            ></H2
        >

        <ScrollableSection
            class="negate-page-section-px"
            content_class="flex gap-4 md:gap-6 flex-nowrap"
        >
            <Worksheets
                {worksheets}
                h_level={3}
                class="snap-center min-w-70 xl:min-w-68"
                feature="worksheets-list-home"
            />
            <ProductListSchema
                products={worksheets}
                name="Worksheets & Lesson Plans"
            />
        </ScrollableSection>
    </PageSection>

    <PageSection class="my-8 lg:my-14">
        <H2 lg class="mb-4 pl-4 md:mb-8"
            ><a
                href="/bundles"
                class="link"
                on:click={() => logEvent('bundles-title-click-home')}
                >Critical Thinking Bundles</a
            ></H2
        >

        <ScrollableSection
            class="negate-page-section-px"
            content_class="flex gap-4 md:gap-6 flex-nowrap"
        >
            <Bundles
                bundles={$page.data.bundles}
                h_level={3}
                class="snap-center min-w-[280px] sm:min-w-[560px]"
                feature="bundle-list-home"
            />
            <ProductListSchema
                products={$page.data.bundles}
                name="Critical Thinking Bundles"
            />
        </ScrollableSection>
    </PageSection>
    
    <PageSection class="my-16 md:my-24">
        <Award class="mx-auto origin-top md:scale-150 lg:scale-[2]" />
    </PageSection>

    <PageSection class="my-12 lg:my-24">
        <div class="grid gap-6 lg:gap-8">
            <Reviews4 reviews={$page.data.reviews} />
        </div>
    </PageSection>

    <PageSection class="my-16 lg:my-24">
        <StoryMission key="who_for" />
    </PageSection>

    {#each $page.data.books as book}
        <BookHero {book} class="my-8 lg:my-16" />
    {/each}

    <PageSection class="my-12">
        <StoryMission />
    </PageSection>

    <PageSection class="my-12">
        <Faq2 class="mx-auto" />
    </PageSection>
</PageLayout>
